import React from 'react'
import { FormattedMessage } from 'react-intl'

import ExternalLink from 'src/comps/ExternalLink'

import styles from './styles.module.css'

interface MessageTermsProps {
  isEmail?: boolean
}

const MessageTerms = ({ isEmail }: MessageTermsProps) => {
  const values = {
    terms: <ExternalLink id="generalConditions" />,
    privacy: <ExternalLink id="privacy" />,
  }

  const messageId = isEmail ? 'global.accept-conditions-email' : 'global.log-in-disclaimer'

  return (
    <p className={styles.termsBase}>
      <FormattedMessage id={messageId} values={values} />
    </p>
  )
}

export default MessageTerms
